'use client';

import { createContext, PropsWithChildren, useContext } from 'react';

interface ServerRenderTimestampContextValue {
    streamId: string | null;
}

const ServerRenderTimestampContext = createContext<ServerRenderTimestampContextValue>({
    streamId: null,
});

export function useServerRenderTimestamp() {
    return useContext(ServerRenderTimestampContext);
}

interface ServerRenderTimestampProviderProps extends PropsWithChildren {
    streamId: string | null;
}

export function ServerRenderTimestampProvider({ streamId, children }: ServerRenderTimestampProviderProps) {
    return (
        <ServerRenderTimestampContext.Provider value={{ streamId }}>
            {children}
        </ServerRenderTimestampContext.Provider>
    );
}
